export default __webpack_public_path__ + "static/text-hero-sync-d08d09bb3c67ba0eb3576f0a713e2c00.png";